export class GameVars {

    public static scaleY: number;
    public static gameData: GameData;
    public static currentScene: Phaser.Scene;
    public static difficulty: string;
    public static currentLevel: number;
    public static paused: boolean;
    public static undoNum: number;
    public static levelData: number[][];
    public static moves: {from: number, to: number}[];
    public static selectedBallsContainer: number;
    public static intitialised: boolean;

    public static typeAd: string;
    public static levelAd: number;
    
    public static formatNumber(value: number): string {

        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    public static getColorName(id: number): string {

        let ret: string;

        switch (id) {
            case 1:
                ret = "green";
                break;
            case 2:
                ret = "red";
                break;
            case 3:
                ret = "yellow";
                break;
            case 4:
                ret = "blue";
                break;
            case 5:
                ret = "cyan";
                break;
            case 6:
                ret = "grey";
                break;
            case 7:
                ret = "pink";
                break;
            case 8:
                ret = "orange";
                break;
            case 9:
                ret = "purple";
                break;
    
            default:
                ret = "none";
                break;
        }

        return ret;
    }
}
